import { useContext, useEffect } from 'react';
import { MaestroDebugContext } from '@ae/maestrov2-form-lib';
import { rendererUrlFor } from '../../utils/maestroSessionSettings';

/**
 * Keeps a mounted Maestro's `programRendererUrl` on the renderer selected in
 * Drive. Maestro only reads `maestro-ui-settings` when it mounts, so a
 * renderer switch has to reach its live settings through the provider —
 * setUiSettings also persists the change. Render inside the Maestro provider.
 */
export default function ProgramRendererUrlSync({ rendererId }) {
  const setUiSettings = useContext(MaestroDebugContext)?.setUiSettings;

  useEffect(() => {
    if (!setUiSettings || !rendererId) return;
    const url = rendererUrlFor(rendererId);
    setUiSettings((prev) => (prev.programRendererUrl === url ? prev : { ...prev, programRendererUrl: url }));
  }, [setUiSettings, rendererId]);

  return null;
}
